<template>
        <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Administración de Regiones
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nueva
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="regiones"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.nombreRegion }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la region-->
    <v-dialog
        v-model="dialog"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-account-question-outline</v-icon>
                </v-btn>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosRegion.nombreRegion"
                                label="Nombre del región"
                                :rules="[
                                    required('Nombre de la región'),
                                    minLength('Nombre de la institución', 5),
                                    alphaRule('Nombre de la institución')
                                ]"
                                maxlength="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosRegion.codigo"
                                label="Código de la región"
                                :rules="[
                                    required('Código de la región')
                                ]"
                                maxlength="5"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la region-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_REGIONES, OBTENER_REGION, REGISTRAR_REGION, ACTUALIZAR_REGION } from "@/core/services/store/region.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

export default {
    name: "AdminRegiones",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            validForm:false,
            itemName : "Regiones",
            dialog: false,
            modalTitle: 'Registrar Región',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Región',
            accion: 1,
            regiones: [],
            switchItemEstado: true,
            datosRegion: {
                id: 0,
                nombreRegion: '',
                codigo:'',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            },
            
            tableLoading: false,
            ...validations
        } 
    }, 
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Región';
            this.btnRegistroText='Registrar Región';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
             this.datosRegion= {
                id: 0,
                nombreRegion: '',
                codigo:'',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            };
            this.switchItemEstado=true;
        },

        //!Obtener los regiones para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.regiones=[];
            
            this.$store
                .dispatch(OBTENER_REGIONES)
                .then(() => {
                    this.regiones = this.$store.state.region.regiones;
                    this.tableLoading =false;
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosRegion.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Región';
            this.btnRegistroText='Actualizar región';

            this.$store
                .dispatch(OBTENER_REGION, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosRegion = this.$store.state.region.region;
                        this.datosRegion.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                         this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                });
        },

        registrarItem(){
            //console.log(this.accion)
            this.btnRegistroLoading=true;
            this.switchItemEstado ? this.datosRegion.estadosId = 1 : this.datosRegion.estadosId = 2;
            if(this.accion===1){
                this.datosRegion.id = 0;
                this.$store
                    .dispatch(REGISTRAR_REGION, this.datosRegion)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_REGION, this.datosRegion)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Regiones" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Código",
                    align: "start",
                    sortable: true,
                    value: "codigo"
                },
                {
                    text: "Nombre de la región",
                    value: "nombreRegion"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }

    
}
</script>
<style lang="">
    
</style>